export enum EExamTab {
  MedicalRecord,
  Directed,
  Prescription,
  SubclinicalAndHistory,
  PathologicalProcess,
  ExamHistory
}
